var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.565,
    height: 27.179,
    viewBox: "0 0 30.565 27.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M99.108,56a1.019,1.019,0,0,0,0,2.039h3.249l3.5,16.53c.139.622.546,1.14,1.062,1.136h16.987a1.019,1.019,0,1,0,0-2.039H107.75l-.435-2.039h17.953a1.051,1.051,0,0,0,.987-.8l2.378-10.192a1.067,1.067,0,0,0-.987-1.242H104.735l-.552-2.59a1.052,1.052,0,0,0-1-.807Zm6.052,5.436h21.2l-1.9,8.154h-17.57Zm5.16,14.948a3.4,3.4,0,1,0,3.4,3.4A3.413,3.413,0,0,0,110.32,76.384Zm10.192,0a3.4,3.4,0,1,0,3.4,3.4,3.413,3.413,0,0,0-3.4-3.4ZM110.32,78.423a1.359,1.359,0,1,1-1.359,1.359A1.344,1.344,0,0,1,110.32,78.423Zm10.192,0a1.359,1.359,0,1,1-1.359,1.359A1.344,1.344,0,0,1,120.512,78.423Z",
    transform: "translate(-98.089 -56)",
    fill: "#0f0f0f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.a1069c1e21b068ef67156a7a8a8671fe.svg";
export { ForwardRef as ReactComponent };